/*
 *
 * ----------------------------------------------- */
jQuery(function ($) {
  $('.list-link').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false
  });
});
